import React, { Component } from 'react'

import SaleNegotiateUpdate from "components/SaleNegotiateUpdate/SaleNegotiateUpdate";

export default class SaleProductUpdateView extends Component {
    render() {
        return (
            <div className="fade-show">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="header">Afiliación - Negociación</h1>
                    </div>
                </div>
                <SaleNegotiateUpdate />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/SaleNegotiateUpdateView/SaleNegotiateUpdateView.jsx